import { http } from "../http";

export const getIdpInfo = async () => {
  try {
    const response = await http.get(`/api/public/idpinfo`);
    return response;
  } catch (ex) {
    console.log(ex);
    return false;
  }
};

export const getJwtToken = async () => {
  try {
    const response = await http.get(`api/session/getJwtToken`);

    return response;
  } catch (ex) {
    console.log(ex);
    return false;
  }
};

export const adminRemoveEmployeeMfa = async (opin) => {
  try {
    const response = await http.get(`/admin/remove_employee_mfa?id=${opin}`);

    return response;
  } catch (ex) {
    console.log(ex);
    return false;
  }
};

export const impersonateUser = async (id) => {
  try {
    const formData = new FormData();
    formData.append("id", id);
    const res = await http.post("/api/impersonate", formData, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    });
    if (res.status === 200) {
      window.open("/user/profile#account", "_blank");
    }
  } catch (error) {
    console.warn(error);
  }
};

export const captchaVerification = async (token) => {
  try {
    const response = await http.post(`/auth/captcha`, {
      "g-recaptcha-response": token,
    });
    return response;
  } catch (ex) {
    console.log(ex);
    return false;
  }
};
